const NoData = ({ className = "", tag = "div", text = "데이터가 없습니다.", style, sub, subStyle, textBtn, refreshOnClick }) => {
	const CustomTag = tag
	return (
		<CustomTag className={`no-data load-center flex-center ${className}`} style={{ minHeight: "30rem", ...style }}>
			<div>
				<div className='center-cont'>
					<i className='icon icon_no_data' />
					<p className='mt_10'>{text}</p>
					{textBtn && (
						<span className="btn-text mt_5" style={{ color: "var(--main-color)" }} onClick={refreshOnClick}>새로고침</span>
					)}
				</div>

				{sub && (
					<div className='text-align_center'>
						<span className='mt_10' style={{ color: "#666", padding: "0 3rem", lineHeight: 1.5, ...subStyle }}>
							{ sub && <span dangerouslySetInnerHTML={{ __html: sub }} />}
						</span>
					</div>
				)}
			</div>
		</CustomTag>
	)
}

export default NoData
